import React, { useEffect, useState } from "react";
import { Grid, Button } from "semantic-ui-react";
import { Field } from "redux-form";
import { renderTextField, renderOptionField } from "../../formcomponents";
import ImageUploadField from "../../formcomponents/ImageUploadField";
import ImageFileUploadFileId from "../../formcomponents/ImageFileUploadFileId";
import { ImageUrl } from "../../formcomponents/Constants";
import pdfIcon from "./pdfIcon.jpeg";
import { useParams } from "react-router-dom";

const FileArrList = ({
  fields,
  imageList,
  meta: { touched, error, submitFailed },
}) => {
  const { urlId, id } = useParams();
  useEffect(() => {
    // fields.push();

    console.log("asibcisbcisbcsc", fields.length);
    if (fields.length === 0) {
      fields.push({}); // Add an empty field if none exist
    }
  }, [imageList, fields]);

  const handleClick = (event, url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const [fileCount, setFileCount] = useState(1);
  const roles = [
    { text: "Establismnent Card", value: "Establismnent Card" },
    { text: "Memorandum", value: "Memorandum" },
    { text: "License", value: "License" },
    { text: "Others", value: "Others" },
  ];

  const [selectedOption, setSelectedOption] = useState({});

  return (
    <ul>
      <Grid columns={5}>
        {fields.map((item, index) => (
          <Grid.Row key={index}>
            <Grid.Column>
              <Field
                name={`${item}.fileType`}
                options={roles}
                component={renderOptionField}
                label="Name"
                onChange={(event, value) =>
                  setSelectedOption({ ...selectedOption, [item]: value })
                }
              />
              {selectedOption[item] === "Others" && (
                <Field
                  name={`${item}.fileDescription`}
                  type="text"
                  component={renderTextField}
                  label="Others Mention Here"
                />
              )}
            </Grid.Column>
            <Grid.Column>
              <br />
              <Field
                name={`${item}.fileName`}
                type="file"
                component={ImageFileUploadFileId}
                label="File"
              />
              {imageList !== "" &&
                imageList.map((itemimg) => {
                  const imageField = fields.get(index)
                    ? fields.get(index).fileStorageId
                    : "";
                  return (
                    <div>
                      {imageField === itemimg.fileStorageId && (
                        <Button
                          style={{
                            padding: "5px",
                            marginTop: "5px",
                          }}
                          type="button"
                          positive
                          floated="right"
                          onClick={(event) =>
                            handleClick(event, ImageUrl + itemimg.fileName)
                          }
                        >
                          Download PDF
                        </Button>
                      )}
                    </div>
                  );
                })}
            </Grid.Column>
            <Grid.Column>
              <Field
                name={`${item}.fileExpiry`}
                type="Date"
                component={renderTextField}
                label="File Expiry"
              />
            </Grid.Column>

            <Grid.Column></Grid.Column>

            <Grid.Column>
              <li style={{ listStyleType: "none", marginTop: "25px" }}>
                <Button
                  type="button"
                  floated="right"
                  negative
                  onClick={() => fields.remove(index)}
                >
                  X
                </Button>
                {fields.length - 1 === index && (
                  <Button
                    type="button"
                    positive
                    floated="right"
                    onClick={() => fields.push({})}
                  >
                    Add
                  </Button>
                )}
              </li>
            </Grid.Column>
          </Grid.Row>
        ))}

        {(touched || submitFailed) && error && <span>{error}</span>}
      </Grid>
      {/* <Grid columns={3}>
        {fields.map((item, index) => (
          <Grid.Row key={index}>
            <Grid.Column>
              <Field
                name={`${item}.fileType`}
                options={roles}
                component={renderOptionField}
                label="Name"
                onChange={(event, value) =>
                  setSelectedOption({ ...selectedOption, [item]: value })
                }
              />
              {selectedOption[item] === "Others" && (
                <Field
                  name={`${item}.fileDescription`}
                  type="text"
                  component={renderTextField}
                  label="Others Mention Here"
                />
              )}
              <Field
                name={`${item}.fileExpiry`}
                type="Date"
                component={renderTextField}
                label="File Expiry"
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name={`${item}.fileName`}
                type="file"
                component={ImageUploadField}
                label="File"
              />
            </Grid.Column>

            <Grid.Column>
              {imageList !== "" &&
                imageList.map((itemimg) => {
                  const imageField = fields.get(index).fileName;
                  return (
                    <>
                      {imageField === itemimg.fileName && (
                        <Button
                          type="button"
                          positive
                          floated="right"
                          onClick={(event) =>
                            handleClick(event, ImageUrl + itemimg.fileName)
                          }
                        >
                          Download PDF
                        </Button>
                      )}
                    </>
                  );
                })}
              <br />
              <li style={{ listStyleType: "none" }}>
                <Button
                  type="button"
                  floated="right"
                  negative
                  onClick={() => fields.remove(index)}
                >
                  X
                </Button>
                {fields.length - 1 === index && (
                  <Button
                    type="button"
                    positive
                    floated="right"
                    onClick={() => fields.push({})}
                  >
                    Add
                  </Button>
                )}
              </li>
            </Grid.Column>
          </Grid.Row>
        ))}
        <br />
      </Grid> */}
    </ul>
  );
};

export default FileArrList;
